module.exports = __webpack_public_path__ + "img/login-logo.c9222609.png";